var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.dark}},[(_vm.toolbar)?_c('v-toolbar',{attrs:{"app":"","color":"primary"}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}})],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('router-view',{attrs:{"dark":_vm.dark}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4a8e8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 